<template>
  <div class="manage">
    <el-drawer :visible.sync="drawer" size="600px">
      <el-form :model="form" ref="form" :rules="rules" class="edit-form">
        <div class="main-content">
          <el-form-item label="账号名称:" prop="name">
            <el-input v-model="form.name" :disabled="formType === 'update'"></el-input>
          </el-form-item>
          <el-form-item label="手机号码:" prop="telephone">
            <el-input v-model="form.telephone"></el-input>
          </el-form-item>

          <el-form-item :label="formType === 'add' ? '账号密码:' : '重置密码:'" prop="password">
            <el-input v-model="form.password" :placeholder="formType === 'add' ? '请输入操作员密码' : '留空则不修改密码'"></el-input>
          </el-form-item>
          <el-form-item label="账号区域:">
            <el-cascader
                v-model="form.areaName"
                :options="areaTree"
                :props="areaTreeProps" :show-all-levels="false"
                @change="handleChange" clearable></el-cascader>
            <!--            <el-select v-model="form.areaName" :popper-append-to-body="false" value-key="id" clearable>-->
            <!--              <el-option :value="selectTree" class="option-style"-->
            <!--                         :key="selectTree.id" :label="selectTree.name">-->
            <!--                <el-tree style="min-height: 150px; max-height: 300px" :data="areaTree" :props="areaTreeProps"-->
            <!--                         ref="tree"-->
            <!--                         check-strictly :expand-on-click-node="false"-->
            <!--                         @node-click="(data, node, item) => nodeClickinCreate(data, node, item)"></el-tree>-->
            <!--              </el-option>-->
            <!--            </el-select>-->
          </el-form-item>
          <el-form-item label="账号角色:" prop="role">
            <el-select v-model="form.role" placeholder="请选择员工角色">
              <el-option v-for="item in roleSelectData" :key="item.value" :label="item.label"
                         :value="item.value" :disabled="!item.mgrEnable"></el-option>
            </el-select>
          </el-form-item>

          <div style="padding-left: 100px; padding-right: 200px ">
            <el-alert v-if="showEnableInfo" title='管理员账号无法分配包含"员工邀约"的角色'
                      type="warning" :closable="false"></el-alert>
          </div>

        </div>

        <div class="footer-content">
          <el-form-item>
            <el-button size="mini" type="primary" @click="onSubmit">确认</el-button>
            <el-button size="mini" @click="drawer = false">取消</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-drawer>

    <div class="header">
      <div class="left">
        <el-row>
          <h3 style="margin: 0 0 20px 0; color: green">系统操作员管理</h3>
        </el-row>

        <el-row class="left-content">
          <el-input prefix-icon="el-icon-search" placeholder="请输入员工姓名" size="small" clearable
                    style="width: 400px; cursor: pointer" v-model="searchContent"/>

          <el-button type="info" plain size="mini" style="margin-left: 5px" @click="search()">搜索</el-button>
        </el-row>
      </div>

      <div class="right">
        <el-button type="primary" size="mini" @click="addEmployee">添加操作员</el-button>
      </div>
    </div>

    <div class="content">
      <el-table :data="tableData" border>
        <el-table-column v-for="(item, index) in tableLabel" :key="index" :prop="item.prop" :label="item.label">
          <template v-slot="scope">
            <template v-if="item.prop === 'state'">
              <el-tag type="warning">
                {{ scope.row['state'] === 'VALID' ? '正常状态' : '禁用状态' }}
              </el-tag>
            </template>

            <template v-else-if="item.prop === 'role'">
              <el-tag>
                {{ roleMap[scope.row.role] }}
              </el-tag>
            </template>

            <template v-else>
              {{ scope.row[item.prop] }}
            </template>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="220px">
          <template v-slot="scope">
            <el-button type="success" size="mini" @click="tableUpdate(scope.row)">修 改</el-button>
            <el-button type="danger" size="mini" @click="tableDelete(scope.row)">删 除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pager">
        <el-pagination layout="prev, pager, next"
                       :total="pagiTotal"
                       :page-size="pagiPageSize"
                       :pager-count="5"
                       :current-page.sync="index"
                       @current-change="handlePagination">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {mixin_table} from '@/utils/mixin'
import {accountCreate, accountDelete, accountUpdate, getAllAccount,} from '@/api/account-api'

import {getAllRoleList} from "@/api/role-api";
import {getAllArea} from "@/api/device-manager-api";

export default {
  mixins: [mixin_table],

  mounted() {
    getAllArea().then(({data}) => {
      this.areaTree = data.data
      this.areaTree.forEach((item) => {
        this.areaMap[item.id] = item
        ;(item.areas || []).forEach((area) => {
          this.areaMap[area.id] = area
          area.areas = null
        })

      })
    }).catch((error) => {
      console.log("getAllArea error =>", error)
    })

    getAllRoleList().then(({data}) => {
      if (data.code === 200) {
        this.roleList = data.data
        data.data.forEach((item) => {
          let enable = true
          this.roleSelectData.push({value: item.id, label: item.name, mgrEnable: enable})
          this.roleMap[item.id] = item.name
        })

      } else {
        this.showServerErrMsg(data.code);
      }
      this.loadTableData()
    }).catch(() => {
      this.showNetErrMsg();
    })


  },

  data() {
    return {
      addRules: {
        name: [{required: true, message: '请输入操作员名称', trigger: 'change'},],
        telephone: [{required: true, message: '请输入操作员手机号', trigger: 'change'},],
        password: [{required: true, message: '请输入操作员密码', trigger: 'change'},],
        type: [{required: true, message: '请选择操作员账号类型', trigger: 'change'},]
      },

      updateRules: {
        name: [{required: true, message: '请输入操作员名称', trigger: 'change'},],
        telephone: [{required: true, message: '请输入操作员手机号', trigger: 'change'},],
        password: [],
        type: [{required: true, message: '请选择操作员账号类型', trigger: 'change'},]
      },

      rules: {
        name: [{required: true, message: '请输入操作员名称', trigger: 'change'},],
        telephone: [{required: true, message: '请输入操作员手机号', trigger: 'change'},],
        password: [{required: true, message: '请输入操作员密码', trigger: 'change'},],
        type: [{required: true, message: '请选择操作员账号类型', trigger: 'change'},]
      },

      searchContent: "",
      tableSelectRow: {},

      drawer: false,
      formType: "",
      form: {},
      tableLabel: [
        {prop: 'name', label: '账号名称'},
        {prop: 'role', label: '账号角色'},
        {prop: 'state', label: '当前状态'},
        {prop: 'telephone', label: '手机号码'},
        {prop: 'superAreaName', label: '账号区域'},
        {prop: 'areaName', label: '账号子区域'},
      ],

      roleSelectData: [
        {value: "MANAGE", label: "系统管理员", mgrEnable: true},
        {value: "VIEW", label: "系统查看员", mgrEnable: true},
        {value: "GUARD", label: "门岗助手", mgrEnable: true},
        // {value: "STAFF", label: "员工邀约", mgrEnable: false},
        {value: "HOME", label: "首页大屏", mgrEnable: true},
      ],
      roleMap: {
        ADMIN: "超级管理员",
        MANAGE: "系统管理员",
        VIEW: "系统查看员",
        GUARD: "门岗助手",
        // STAFF: "员工邀约",
        HOME: "首页大屏",
      },
      showEnableInfo: false,
      roleList: [],
      areaTree: [],
      areaTreeProps: {
        children: "areas",
        label: "name",
        value: "id"
      },
      areaMap: {},
      selectTree: "",
    }
  },

  computed: {
    ...mapState(['loginInfo'])
  },

  methods: {

    search() {
      if (this.searchContent === "") {
        this.tableShowData = this.tableAllData
      } else {
        this.tableShowData = this.tableAllData.filter(item => item.name.search(this.searchContent) !== -1)
      }
      this.initPaginationTable()
    },

    onSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {

          if (this.formType === "update") {
            this.onSubmitUpdate()
          } else if (this.formType === "add") {
            this.onSubmitAdd()
          }
        } else {
          console.log('validate error, error submit!!');
          return false;
        }
      });
    },

    checkPassword(password) {
      if (!password) {
        return "请输入密码";
      }
      if (password.length < 8 || password.length > 16) {
        return "密码长度需要设置为8位-16位";
      }
      let passCount = 0;
      let hasUpper = false;
      let hasLower = false;
      let hasNumber = false;
      let hasSpecial = false;
      const specialChars = "!@#$%^&*()_+{}|:<>?~`-=[];',./";
      for (let i = 0; i < password.length; i++) {
        const c = password.charAt(i);
        if (c >= 'A' && c <= 'Z') {
          hasUpper = true;
        } else if (c >= 'a' && c <= 'z') {
          hasLower = true;
        } else if (c >= '0' && c <= '9') {
          hasNumber = true;
        } else if (specialChars.indexOf(c) >= 0) {
          hasSpecial = true;
        }
      }
      if (hasUpper) passCount++;
      if (hasLower) passCount++;
      if (hasNumber) passCount++;
      if (hasSpecial) passCount++;
      if (passCount < 3) {
        return "密码需要包含大写字母、小写字母、数字、特殊符号中的三种";
      }
      return null;
    },

    onSubmitUpdate() {
      console.log("this.form =>", this.form)
      let roleType = this.form.role
      let roleValue = null
      if (!["MANAGE", "VIEW", "GUARD", "STAFF", "HOME"].includes(this.form.role)) {
        roleType = "COMMON"
        roleValue = this.form.role
      }
      if (this.form.areaName && this.form.areaName.length === 2) {
        this.form.areaId = this.form.areaName[1]
      }
      let postData = {
        id: this.form.id,
        name: this.form.name,
        telephone: this.form.telephone,
        roleType: roleType,
        roleValue: roleValue,
        areaId: this.form.areaId
      }
      // 若填写了密码则校验并提交
      if (this.form.password) {
        let pwdErr = this.checkPassword(this.form.password);
        if (pwdErr) {
          this.$message.error(pwdErr);
          return;
        }
        postData.password = this.form.password;
      }
      console.log("onSubmitUpdate postData =>", postData)
      accountUpdate(postData).then(({data}) => {
        console.log("data =>", data)

        if (data.code === 200) {
          let row = this.tableSelectRow
          for (var key in data.data) {
            // console.log("key = ", key)
            row[key] = data.data[key]
          }

          row.createTime = this.getShowTime(row.createTime)
          row.updateTime = this.getShowTime(row.updateTime)
          row.role = row.roleType === "COMMON" ? row.roleValue : row.roleType
          this.drawer = false
          this.$message.success("更新成功");
          this.loadTableData()
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch((error) => {
        console.log("accountUpdate", error)
        this.showNetErrMsg();
      })
    },

    onSubmitAdd() {
      let roleType = this.form.role
      let roleValue = null
      if (!["MANAGE", "VIEW", "GUARD", "STAFF"].includes(this.form.role)) {
        roleType = "COMMON"
        roleValue = this.form.role
      }
      if (this.form.areaName && this.form.areaName.length === 2) {
        this.form.areaId = this.form.areaName[1]
      }

      let pwdErr = this.checkPassword(this.form.password);
      if (pwdErr) {
        this.$message.error(pwdErr);
        return;
      }

      let postData = {
        name: this.form.name,
        telephone: this.form.telephone,
        password: this.form.password,
        roleType: roleType,
        roleValue: roleValue,
        areaId: this.form.areaId,
      }
      console.log("onSubmitAdd postData =>", postData)
      accountCreate(postData).then(({data}) => {

        if (data.code === 200) {
          let account = data.data

          account.createTime = this.getShowTime(account.createTime)
          account.updateTime = this.getShowTime(account.updateTime)
          account.role = account.roleType === "COMMON" ? account.roleValue : account.roleType
          this.tableAllData.push(account)
          this.tableShowData.push(account)
          this.initPaginationTable()

          this.drawer = false
          this.$message.success("添加账号成功");
          this.loadTableData()
        } else if (data.code === 700) {
          this.$message.error("存在同名的账号");
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch(({error}) => {
        console.log("accountCreate", error)
        this.showNetErrMsg();
      })
    },

    addEmployee() {
      this.formType = "add"
      this.form = {
        "name": "",
        "telephone": "",
        "password": "",
        "role": "",
        "areaId": "",
        "areaName": "",
      }
      this.$refs["form"] && this.$refs["form"].clearValidate();
      this.rules = this.addRules;
      console.log("form =>", this.form)
      this.drawer = true
    },

    tableUpdate(row) {
      this.formType = "update"
      console.log("tableUpdate row =>", row)
      this.tableSelectRow = row

      let role = row.roleType
      if (row.roleType === "COMMON") {
        role = row.roleValue
      }
      let areaName = ""
      if (row.areaId) {
        let area = this.areaMap[row.areaId]
        areaName = [area.parentId, area.id]
      }
      this.form = {
        "id": row.id,
        "name": row.name,
        "telephone": row.telephone,
        "password": "",
        "role": role,
        "areaId": "",
        "areaName": areaName
      }
      this.$refs["form"] && this.$refs["form"].clearValidate();
      this.rules = this.updateRules;

      this.drawer = true
    },

    tableDelete(row) {
      accountDelete(row.id).then(({data}) => {
        if (data.code === 200) {
          this.tableAllData = this.tableAllData.filter(item => item.id !== row.id)
          this.tableShowData = this.tableShowData.filter(item => item.id !== row.id)

          this.initPaginationTable()

          this.$message.success('删除成功');
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch((error) => {
        console.log("accountDelete error => ", error)
        this.showNetErrMsg();
      })
    },

    loadTableData() {
      getAllAccount().then(({data}) => {
        console.log("getAllAccount =>", data)
        data.data = data.data.filter(item => {
          if (item.id === this.loginInfo.id) {
            return false
          }
          if (item.state === "INVALID") {
            return false
          }

          if (item.roleType === "ADMIN") {
            return false
          }
          return true
        })

        data.data.forEach((item, index) => {
          let superAreaName = "", areaName = ""
          if (item.areaId) {
            let area = this.areaMap[item.areaId]
            let superArea = area ? this.areaMap[area.parentId] : ""
            superAreaName = superArea ? superArea.name : ""
            areaName = area ? area.name : ""
          }
          data.data[index].createTime = this.getShowTime(item.createTime)
          data.data[index].updateTime = this.getShowTime(item.updateTime)
          data.data[index].role = item.roleType === "COMMON" ? item.roleValue : item.roleType
          data.data[index].superAreaName = superAreaName
          data.data[index].areaName = areaName
        })

        this.tableShowData = []
        this.tableAllData = data.data

        this.tableAllData.forEach((item) => {
          this.tableShowData.push(item)
        })

        this.initPaginationTable()
      }).catch((error) => {
        console.log("error =>", error)
      })
    },

    getShowTime(timeStr) {
      let time = new Date(timeStr)
      return time.getFullYear() + '-' + time.getMonth() + "-" + time.getDay()
          + ' ' + time.getHours() + ':' + time.getMinutes() + ':' + time.getSeconds()
    },

    nodeClickinCreate(e) {
      console.log(e);
      this.form.areaId = e.id
      this.form.areaName = e.name
      this.selectTree = e
    },
    handleChange(value) {
      console.log(value);
      console.log(this.form.areaName)
    }
  },
}
</script>

<style lang="less" scoped>

.manage {
  background: rgb(255, 255, 255);
  height: calc(100vh - 120px);

  .edit-form {
    display: flex;
    flex-direction: column;
    text-align: center;
    height: 100%;
    margin-left: 50px;

    .header-content {
      margin-bottom: 20px;
    }

    .main-content {
      flex: 1 0 auto;

      .el-form-item {
        display: flex;
        justify-content: flex-start;

        /deep/ .el-form-item__label {
          width: 100px;
        }

        /deep/ .el-input {
          width: calc(20vw);
        }
      }
    }

    .footer-content {
      text-align: center;
      flex: 0 0 auto;
    }
  }

  .header {
    display: flex;
    justify-content: space-between;

    .left-content {
      // display: flex;
      // justify-content: flex-start;

      margin-bottom: 20px;
    }

    .right {
      margin: 40px 0 0 0; //上 右 下 左
    }
  }

  .content {
    //margin: 0 10px 0px 10px; //上 右 下 左
  }
}

.option-style {
  overflow: auto;
  height: 100%;
}

</style>
